// Trạng thái chương trình / gói chiết khấu (computed — nhãn UI: LOYALTY_STATUS_LABEL / vi.json)
export const LOYALTY_PACKAGE_STATUS = {
  UPCOMING: "UPCOMING",
  ONGOING: "ONGOING",
  RECONCILING: "RECONCILING",
  RECONCILED: "RECONCILED",
  COMPLETED: "COMPLETED",
};

/** Số ngày đối soát/quyết toán sau endTime */
export const LOYALTY_RECONCILIATION_DAYS = 10;

// Đơn vị thưởng chiết khấu
export const REWARD_UNIT = {
  PER_PRODUCT: "PER_PRODUCT", // tiền/sp
  PER_MILESTONE: "PER_MILESTONE", // tiền/mốc
  HAP: "HAP", // tiền HAP
  GIFT_PER_AWARD: "GIFT_PER_AWARD", // quà/gói
};

// Tỷ giá quy đổi 1 HAP = 1.000đ. BE yêu cầu awardValue luôn ở dạng VNĐ để SUM tổng tiền theo quý/tháng.
// FE nhân khi gửi (HAP → VNĐ) và chia khi đọc về (VNĐ → HAP) cho đơn vị HAP; đơn vị tiền khác giữ nguyên.
export const HAP_TO_VND = 1000;

// Loại thời gian gói chiết khấu (API: timeInterval / BE: PolicyTimeInterval)
export const LOYALTY_TIME_INTERVAL = {
  MONTH: "MONTH",
  QUARTER: "QUARTER",
  SEMIANNUAL: "SEMIANNUAL",
  YEAR: "YEAR",
};

// Phạm vi áp dụng sản phẩm trong gói (API: applyScope)
export const LOYALTY_APPLY_SCOPE = {
  SINGLE_PRODUCT: "SINGLE_PRODUCT",
  MULTIPLE_PRODUCTS: "MULTIPLE_PRODUCTS",
};

// Tabs trên màn Cấu hình chiết khấu
export const LOYALTY_TAB_KEY = {
  PROGRAM: "program",
  PACKAGE: "package",
};

// Giới hạn field
export const LOYALTY_FIELD_LIMITS = {
  NAME_MAX_LENGTH: 255,
  MIN_MILESTONES: 1,
};

/** Page size filter "Thuộc chương trình" (tab Gói) — load thêm khi scroll */
export const LOYALTY_PROGRAM_FILTER_PAGE_SIZE = 15;

// Mode form chương trình (ProgramFormModal)
export const PROGRAM_FORM_MODE = {
  CREATE: "create",
  EDIT: "edit",
  COPY: "copy",
};

// Mode form gói chiết khấu (PackageForm)
export const PACKAGE_FORM_MODE = {
  CREATE: "create",
  EDIT: "edit",
  COPY: "copy",
};

// Màu badge trạng thái
export const LOYALTY_STATUS_COLOR = {
  [LOYALTY_PACKAGE_STATUS.UPCOMING]: "#EF9351",
  [LOYALTY_PACKAGE_STATUS.ONGOING]: "#32BF46",
  [LOYALTY_PACKAGE_STATUS.RECONCILING]: "#8C8C8C",
  [LOYALTY_PACKAGE_STATUS.RECONCILED]: "#1890FF",
  [LOYALTY_PACKAGE_STATUS.COMPLETED]: "#8C8C8C",
};

// Nhãn trạng thái (dùng trong select filter, badge)
export const LOYALTY_STATUS_LABEL = {
  [LOYALTY_PACKAGE_STATUS.UPCOMING]: "Chưa diễn ra",
  [LOYALTY_PACKAGE_STATUS.ONGOING]: "Đang diễn ra",
  [LOYALTY_PACKAGE_STATUS.RECONCILING]: "Đang quyết toán",
  [LOYALTY_PACKAGE_STATUS.RECONCILED]: "Đã quyết toán",
  [LOYALTY_PACKAGE_STATUS.COMPLETED]: "Đã kết thúc",
};

export const REWARD_UNIT_LABEL = {
  [REWARD_UNIT.PER_PRODUCT]: "tiền/sp",
  [REWARD_UNIT.PER_MILESTONE]: "tiền/mốc",
  [REWARD_UNIT.HAP]: "HAP",
  [REWARD_UNIT.GIFT_PER_AWARD]: "Quà/gói",
};

export const LOYALTY_TIME_INTERVAL_LABEL = {
  [LOYALTY_TIME_INTERVAL.MONTH]: "Tháng",
  [LOYALTY_TIME_INTERVAL.QUARTER]: "Quý",
  [LOYALTY_TIME_INTERVAL.SEMIANNUAL]: "6 tháng",
  [LOYALTY_TIME_INTERVAL.YEAR]: "Năm",
};

export const LOYALTY_APPLY_SCOPE_LABEL = {
  [LOYALTY_APPLY_SCOPE.SINGLE_PRODUCT]: "Một sản phẩm",
  [LOYALTY_APPLY_SCOPE.MULTIPLE_PRODUCTS]: "Nhiều sản phẩm",
};

// Dropdown options — form gói (đổi tên 2 option cũ + thêm option Quà/gói)
export const REWARD_UNIT_OPTIONS = [
  { value: REWARD_UNIT.HAP, label: "HAP" },
  { value: REWARD_UNIT.PER_PRODUCT, label: "Tiền/sản phẩm" },
  { value: REWARD_UNIT.PER_MILESTONE, label: "Tiền/gói" },
  { value: REWARD_UNIT.GIFT_PER_AWARD, label: "Quà/gói" },
];

/** Dropdown form gói — chỉ Tháng, Quý (BE có thêm SEMIANNUAL/YEAR cho tương lai) */
export const TIME_INTERVAL_OPTIONS = [
  { value: LOYALTY_TIME_INTERVAL.MONTH, label: LOYALTY_TIME_INTERVAL_LABEL[LOYALTY_TIME_INTERVAL.MONTH] },
  { value: LOYALTY_TIME_INTERVAL.QUARTER, label: LOYALTY_TIME_INTERVAL_LABEL[LOYALTY_TIME_INTERVAL.QUARTER] },
];

export const APPLY_SCOPE_OPTIONS = [
  { value: LOYALTY_APPLY_SCOPE.SINGLE_PRODUCT, label: LOYALTY_APPLY_SCOPE_LABEL[LOYALTY_APPLY_SCOPE.SINGLE_PRODUCT] },
  {
    value: LOYALTY_APPLY_SCOPE.MULTIPLE_PRODUCTS,
    label: LOYALTY_APPLY_SCOPE_LABEL[LOYALTY_APPLY_SCOPE.MULTIPLE_PRODUCTS],
  },
];

// Mapping field DB → API
// DB: name       → API: title
// DB: period     → API: time_interval
export const LOYALTY_FIELD_MAP = {
  DB_NAME: "title",
  DB_PERIOD: "time_interval",
};
